import React from "react";
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';
import {Doughnut} from 'react-chartjs-2';

export class PopularProducts extends React.Component {
    state = {
        chartData: {},
    }

    componentDidMount() {
        this.fetchGraphData();
    }

    fetchGraphData = async () => {
        axios.get('/dashboard/popularProductsGraph')
            .then(data => {
                console.log(data);
                this.setState({
                    chartData: data
                });
            })
            .catch (err => {
              console.log(err);
              Rollbar.error(err)
              toast.error('Failed to get popular products')
            })
    }

    render() {
        return (
            <div className="card">
                <div className="card-body">
                    <Doughnut data={this.state.chartData} />
                </div>
            </div>
        );
    }
}
